import React from "react";
import { NavLink } from "react-router-dom";

class BlogSidebar extends React.Component {
  render() {
    return (
      <>
        <div className="side-bar p-a30 bg-gray">
          {/* SEARCH */}
          {/* <div className="widget">
                        <h4 className="widget-title ">Search</h4>
                        <div className="search-bx p-a10 bg-white">
                            <form role="search" method="post" action="#">
                                <div className="input-group">
                                    <input name="news-letter" type="text" className="form-control bg-gray" placeholder="Write your text" />
                                    <span className="input-group-btn bg-gray">
                                        <button type="button" className="btn"><i className="fa fa-search" /></button>
                                    </span>
                                </div>
                            </form>
                        </div>
                    </div> */}
          {/* RECENT POSTS */}
          <div className="widget  recent-posts-entry">
            <h4 className="widget-title  ">Récents Actualités</h4>
            <div className="section-content p-a10 bg-white">
              <div className="widget-post-bx">
                <div className="widget-post clearfix">
                  <div className="sx-post-media">
                    <img
                      src={require("./../../images/blog/event_2.jpg")}
                      alt=""
                    />
                  </div>
                  <div className="sx-post-info">
                    <div className="sx-post-header">
                      <h6 className="post-title">
                      COMMUNIQUE Projet Vallée Val d’OR II
                      </h6>
                    </div>
                    <div className="sx-post-meta">
                      <ul>
                        <li className="post-author">31 Dec 2020</li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div className="widget-post clearfix">
                  <div className="sx-post-media">
                    <img
                      src={require("../../images/annonces/image1.jpg")}
                      alt=""
                    />
                  </div>
                  <div className="sx-post-info">
                    <div className="sx-post-header">
                      <h6 className="post-title">
                      COMMUNIQUE Projet Vallée Val d’OR I
                      </h6>
                    </div>
                    <div className="sx-post-meta">
                      <ul>
                        <li className="post-author">25 Sep 2022</li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div className="widget-post clearfix">
                  <div className="sx-post-media">
                    <img
                      src={require("../../images/annonces/default.jpg")}
                      alt=""
                    />
                  </div>
                  <div className="sx-post-info">
                    <div className="sx-post-header">
                      <h6 className="post-title">
                      إخبـــار
                      </h6>
                    </div>
                    <div className="sx-post-meta">
                      <ul>
                        <li className="post-author">26 Nov 2022</li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* NEWSLETTER */}
          <div className="widget widget_newsletter-2">
            <h4 className="widget-title  ">Newsletter</h4>
            <div className="newsletter-bx p-a10 bg-white">
              <div className="newsletter-content">
                <p>
                  Soyez les premiers informés de nos actualités en vous
                  inscrivant à notre newsletter.
                </p>
              </div>
              <div className="m-t20">
                <form role="search" method="post" action="#">
                  <div className="input-group">
                    <input
                      name="news-letter"
                      className="form-control"
                      placeholder="Entrer votre Email"
                      type="text"
                    />
                    <span className="input-group-btn">
                      <button type="button" className="site-button">
                        <i className="fa fa-paper-plane-o" />
                      </button>
                    </span>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default BlogSidebar;
